import { useEffect, useState } from 'react'
import {
  Alert,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField
} from '@mui/material'
import { isBlank } from '../../utils/string'
import CausaPerdidoSelector from '../../components/form/CausaPerdidoSelector/CausaPerdidoSelector'
import CausaNoValidoSelector from '../../components/form/CausaNoValidoSelector/CausaNoValidoSelector'
import AlumnoSelector from '../../components/form/AlumnoSelector/AlumnoSelector'
import css from './ModalContactoLeadCerrado.module.css'

const EstadoLeadPicker = ({ value, isSuccessEnabled, onChange }) => (
  <FormControl className={css.selector}>
    <RadioGroup
      row
      name='estado-lead'
      value={value}
      onChange={onChange}
      className={css.radioGroup}
    >
      {isSuccessEnabled && (
        <FormControlLabel
          value='CLIENTE_CAPTADO'
          control={<Radio />}
          label='Cliente captado'
        />
      )}
      <FormControlLabel
        value='CLIENTE_PERDIDO'
        control={<Radio />}
        label='Lead perdido'
      />
      <FormControlLabel
        value='LEAD_NO_VALIDO'
        control={<Radio />}
        label='Lead no válido'
      />
      <FormControlLabel
        value='LEAD_DERIVADO'
        control={<Radio />}
        label='Lead derivado'
      />
    </RadioGroup>
  </FormControl>
)

const ModalContactoLeadCerrado = ({
  open,
  disabled,
  isSuccessEnabled = false,
  onSubmit,
  onClose
}) => {
  const [estadoLead, setEstadoLead] = useState('')

  const [lead, setLead] = useState({
    alumno: {},
    contactado: true,
    causa_perdido: '',
    causa_no_valido: '',
    observaciones: ''
  })

  useEffect(() => {
    setLead({
      alumno: {},
      contactado: true,
      causa_perdido: '',
      causa_no_valido: '',
      observaciones: ''
    })
    setEstadoLead('')
  }, [open])

  useEffect(() => {
    setLead(current => ({
      alumno: {},
      contactado: true,
      causa_perdido: '',
      causa_no_valido: '',
      observaciones: current.observaciones
    }))
  }, [estadoLead])

  const isSubmitDisabled =
    (estadoLead === 'CLIENTE_PERDIDO' && isBlank(lead.causa_perdido)) ||
    (estadoLead === 'LEAD_NO_VALIDO' && isBlank(lead.causa_no_valido)) ||
    (estadoLead === 'CLIENTE_CAPTADO' && isBlank(lead.alumno.id)) ||
    (estadoLead === 'LEAD_DERIVADO' && isBlank(lead.observaciones))

  const handleSubmit = () => {
    const data = {
      leadStatus: estadoLead,
      contactado: lead.contactado,
      observaciones: lead.observaciones
    }
    if (estadoLead === 'CLIENTE_CAPTADO') data.alumnoCaptado = lead.alumno.id
    if (estadoLead === 'CLIENTE_PERDIDO') data.causaPerdido = lead.causa_perdido
    if (estadoLead === 'LEAD_NO_VALIDO') {
      data.causaNoValido = lead.causa_no_valido
    }

    onSubmit(data)
  }

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='md'>
      <DialogTitle>Datos del lead cerrado</DialogTitle>
      <DialogContent className={css.main}>
        <DialogContentText className={css.intro}>
          Rellena los datos necesarios para marcar el lead como cerrado
        </DialogContentText>
        <EstadoLeadPicker
          isSuccessEnabled={isSuccessEnabled}
          value={estadoLead}
          onChange={e => setEstadoLead(e.target.value)}
        />
        {estadoLead === 'CLIENTE_CAPTADO' && (
          <>
            <Alert className={css.alert} severity='warning'>
              Esta opción solo se debe utilizar para asociar{' '}
              <strong>antiguos leads</strong> a fichas de alumno existentes. La
              forma normal de cerrar un lead es creando una ficha nueva de
              alumno y asociando el lead a esa ficha.
            </Alert>
            <AlumnoSelector
              className={css.input}
              name='alumno'
              label='Alumno'
              value={lead.alumno}
              onChange={(_e, value) => setLead({ ...lead, alumno: value })}
            />
          </>
        )}
        {estadoLead === 'CLIENTE_PERDIDO' && (
          <CausaPerdidoSelector
            className={css.input}
            name='causa-perdido'
            label='Motivo de cierre'
            value={lead.causa_perdido}
            onChange={e => setLead({ ...lead, causa_perdido: e.target.value })}
          />
        )}
        {estadoLead === 'LEAD_NO_VALIDO' && (
          <CausaNoValidoSelector
            className={css.input}
            name='causa-no-valido'
            label='Motivo de cierre'
            value={lead.causa_no_valido}
            onChange={e =>
              setLead({ ...lead, causa_no_valido: e.target.value })
            }
          />
        )}
        {estadoLead && (
          <TextField
            className={css.input}
            label='Observaciones'
            multiline
            value={lead.observaciones}
            onChange={e => setLead({ ...lead, observaciones: e.target.value })}
            variant='standard'
          />
        )}
        {['CLIENTE_PERDIDO', 'LEAD_NO_VALIDO'].includes(estadoLead) && (
          <FormControlLabel
            control={
              <Checkbox
                checked={!lead.contactado}
                onChange={e =>
                  setLead({ ...lead, contactado: !e.target.checked })
                }
              />
            }
            label='No se ha podido contactar con el lead'
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button color='error' disabled={disabled} onClick={onClose}>
          Cancelar
        </Button>
        <Button
          disabled={isSubmitDisabled || disabled}
          color='primary'
          onClick={handleSubmit}
        >
          Cerrar lead
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalContactoLeadCerrado
